import CartPage from "./components/CartPage.vue";

const app = new Vue({
    el: '#cart-page',
    components: {CartPage}
});
